import { AccessTokenPayload, Role, UserInformation } from '@algoan/dashboard/model';

/* eslint-disable @typescript-eslint/naming-convention */
// properties are coming from the backend, we can't name them correctly
export const convertAccessTokenPayloadToUserInformation = (accessTokenPayload: AccessTokenPayload): UserInformation => {
  const roles =
    accessTokenPayload?.resource_access?.['console-backend']?.roles.map((role) => `console-backend:${role}`) ?? [];

  return {
    id: accessTokenPayload.sub,
    familyName: accessTokenPayload.family_name,
    name: accessTokenPayload.name,
    givenName: accessTokenPayload.given_name,
    email: accessTokenPayload.email,
    preferredUsername: accessTokenPayload.preferred_username,
    team: accessTokenPayload.team,
    // generate high contrast HSL value based on email address
    color: stringToColor(accessTokenPayload.email),
    organizationId: accessTokenPayload.organizationIds,
    projectIds: accessTokenPayload.projectIds,
    canAcceptMarketing: accessTokenPayload.canAcceptMarketing === 'on',
    roles: roles as Role[],
    isDashboardUser: accessTokenPayload.isDashboardUser === 'true',
  };
};
/* eslint-enable @typescript-eslint/naming-convention */

// https://stackoverflow.com/questions/3426404/create-a-hexadecimal-colour-based-on-a-string-with-javascript
const stringToColor = (stringInput: string): string => {
  const hashCode = (stringInput: string): number => {
    let hash = 0;
    for (let i = 0; i < stringInput.length; i++) {
      hash = stringInput.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  };

  // these HSL values ensure high levels of contrast
  return `hsl(${hashCode(stringInput) % 360}, 100%, 40%)`;
};
